const defaulState = {
  selectedIncident: {},
  unitsCatalog: [],
};

const getters = {
  getSelectedIncident: (state) => state.selectedIncident,
  getSelectedIncidentId: (state) => state.selectedIncident?.id,
  getUnitsCatalog: (state) => state.unitsCatalog,
};

const actions = {
  setSelectedIncident({ commit }, item) {
    commit('SET_SELECTED_INCIDENT', item);
  },
  setUnitsCatalog({ commit }, items) {
    commit('SET_UNITS_CATALOG', items);
  },
  setUnitCatalog({ commit }, item) {
    commit('SET_UNIT_CATALOG', item);
  },
};

const mutations = {
  SET_SELECTED_INCIDENT(state, item) {
    state.selectedIncident = item;
  },
  SET_UNITS_CATALOG(state, items) {
    state.unitsCatalog = items;
  },
  SET_UNIT_CATALOG(state, item) {
    const index = state.unitsCatalog.findIndex((i) => i.identifier === item.identifier);
    if (index !== -1) {
      state.unitsCatalog[index] = item;
    } else {
      state.unitsCatalog.push(item);
    }
  },
};

export default {
  namespaced: true,
  state() {
    return defaulState;
  },
  getters,
  actions,
  mutations,
};
